"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMultiSelect = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var select_1 = require("@blueprintjs/select");
var lodash_1 = require("lodash");
var Popover = core_1.Popover;
var VMultiSelect = (function (_super) {
    __extends(VMultiSelect, _super);
    function VMultiSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: (_this.props.popoverProps && _this.props.popoverProps.isOpen) || false
        };
        _this.TypedQueryList = select_1.QueryList.ofType();
        _this.input = null;
        _this.queryList = null;
        _this.refHandlers = {
            input: function (ref) {
                var _a;
                _this.input = ref;
                ((_a = _this.props) === null || _a === void 0 ? void 0 : _a.tagInputProps) &&
                    (0, lodash_1.invoke)(_this.props.tagInputProps, 'inputRef', ref);
            },
            queryList: function (ref) { return (_this.queryList = ref); }
        };
        _this.renderQueryList = function (listProps) {
            var _a = _this.props, fill = _a.fill, _b = _a.tagInputProps, tagInputProps = _b === void 0 ? {} : _b, _c = _a.popoverProps, popoverProps = _c === void 0 ? {} : _c, _d = _a.selectedItems, selectedItems = _d === void 0 ? [] : _d, placeholder = _a.placeholder;
            var handlePaste = listProps.handlePaste, handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            if (fill) {
                popoverProps.fill = true;
                tagInputProps.fill = true;
            }
            var _e = tagInputProps.inputProps, inputProps = _e === void 0 ? {} : _e;
            inputProps.className = "".concat(inputProps.className, " ").concat(select_1.Classes.MULTISELECT_TAG_INPUT_INPUT);
            var handleTagInputAdd = function (values, method) {
                return method === 'paste' && handlePaste(values);
            };
            return (react_1.default.createElement(Popover, __assign({ autoFocus: false, canEscapeKeyClose: true, enforceFocus: false, isOpen: _this.state.isOpen, position: core_1.Position.BOTTOM_LEFT }, popoverProps, { shouldReturnFocusOnClose: false, className: "".concat(listProps.className, " ").concat(popoverProps.className), onInteraction: _this.handlePopoverInteraction, popoverClassName: "".concat(select_1.Classes.MULTISELECT_POPOVER, " ").concat(popoverProps.popoverClassName), onOpened: _this.handlePopoverOpened }),
                react_1.default.createElement("div", { onKeyDown: _this.getTagInputKeyDownHandler(handleKeyDown), onKeyUp: _this.getTagInputKeyUpHandler(handleKeyUp) },
                    react_1.default.createElement(core_1.TagInput, __assign({ placeholder: placeholder }, tagInputProps, { className: "".concat(select_1.Classes.MULTISELECT, " ").concat(tagInputProps.className), inputRef: _this.refHandlers.input, inputProps: inputProps, inputValue: listProps.query, onAdd: handleTagInputAdd, onInputChange: listProps.handleQueryChange, values: selectedItems.map(_this.props.tagRenderer) }))),
                react_1.default.createElement("div", { onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }, listProps.itemList)));
        };
        _this.handleItemSelect = function (item, evt) {
            var _a;
            (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus();
            core_1.Utils.safeInvoke(_this.props.onItemSelect, item, evt);
        };
        _this.handleQueryChange = function (query, evt) {
            _this.setState({ isOpen: query.length > 0 || !_this.props.openOnKeyDown });
            core_1.Utils.safeInvoke(_this.props.onQueryChange, query, evt);
        };
        _this.handlePopoverInteraction = function (nextOpenState) {
            return requestAnimationFrame(function () {
                if (_this.input != null && _this.input !== document.activeElement) {
                    _this.setState({ isOpen: false });
                }
                else if (!_this.props.openOnKeyDown) {
                    _this.setState({ isOpen: true });
                }
                core_1.Utils.safeInvokeMember(_this.props.popoverProps, 'onInteraction', nextOpenState);
            });
        };
        _this.handlePopoverOpened = function (node) {
            var _a, _b;
            (_a = _this.queryList) === null || _a === void 0 ? void 0 : _a.scrollActiveItemIntoView();
            if (_this.props.resetOnClose) {
                (_b = _this.queryList) === null || _b === void 0 ? void 0 : _b.setQuery('', true);
            }
            core_1.Utils.safeInvokeMember(_this.props.popoverProps, 'onOpened', node);
        };
        _this.getTagInputKeyDownHandler = function (handleQueryListKeyDown) { return function (e) {
            var _a;
            var which = e.which;
            if (which === core_1.Keys.ESCAPE || which === core_1.Keys.TAB) {
                (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur();
                _this.setState({ isOpen: false });
            }
            else if (!(which === core_1.Keys.BACKSPACE ||
                which === core_1.Keys.ARROW_LEFT ||
                which === core_1.Keys.ARROW_RIGHT)) {
                _this.setState({ isOpen: true });
            }
            var isTargetingTagRemoveButton = e.target.closest(".".concat(core_1.Classes.TAG_REMOVE)) != null;
            if (_this.state.isOpen && !isTargetingTagRemoveButton) {
                core_1.Utils.safeInvoke(handleQueryListKeyDown, e);
            }
        }; };
        _this.getTagInputKeyUpHandler = function (handleQueryListKeyUp) { return function (e) {
            var isTargetingInput = e.target.classList.contains(select_1.Classes.MULTISELECT_TAG_INPUT_INPUT);
            if (_this.state.isOpen && isTargetingInput) {
                core_1.Utils.safeInvoke(handleQueryListKeyUp, e);
            }
        }; };
        return _this;
    }
    VMultiSelect.ofType = function () {
        return VMultiSelect;
    };
    VMultiSelect.prototype.render = function () {
        var _a = this.props, openOnKeyDown = _a.openOnKeyDown, popoverProps = _a.popoverProps, tagInputProps = _a.tagInputProps, restProps = __rest(_a, ["openOnKeyDown", "popoverProps", "tagInputProps"]);
        return (react_1.default.createElement(this.TypedQueryList, __assign({}, restProps, { onItemSelect: this.handleItemSelect, onQueryChange: this.handleQueryChange, ref: this.refHandlers.queryList, renderer: this.renderQueryList })));
    };
    VMultiSelect.displayName = "".concat(core_1.DISPLAYNAME_PREFIX, ".MultiSelect");
    VMultiSelect.defaultProps = { fill: false, placeholder: 'Search...' };
    return VMultiSelect;
}(react_1.default.PureComponent));
exports.VMultiSelect = VMultiSelect;
